import styled from 'styled-components'
import { colors } from '~/design'
import OriginalLink from '~/prix/react/components/link'
import { menuBoxShadow } from './menu'
import useMedia from 'react-use/lib/useMedia'
import { BaSeIcon } from '@base/react'

const Wrapper = styled.div<{ $shadow?: boolean }>`
  position: relative;
  display: flex;
  width: 83px;
  flex-direction: column;
  order: 1;
  border-right: ${({ $shadow }) => ($shadow ? 'none' : `1px solid ${colors.gray}`)};
  box-shadow: ${({ $shadow }) => ($shadow ? menuBoxShadow : 'none')};
  overflow: auto;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 3;

  @media (max-width: 768px) {
    bottom: 0;
    width: 100%;
    order: 4;
    overflow: auto;
    overflow-x: auto;
    overflow-y: hidden;
  }
`

const NavIconList = styled.nav`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  flex: 1 0;

  span.anonymization {
    vertical-align: bottom;
  }

  footer {
    position: absolute;
    bottom: 10px;
    text-align: center;
  }

  a {
    padding: 12px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (max-width: 768px) {
    flex-direction: row;
    padding-bottom: 0;
    min-height: 58px;

    span,
    span.anonymization {
      display: none;
    }

    footer {
      position: relative;
      bottom: 0px;
    }
  }
`

const Link = styled(OriginalLink)`
  display: flex;
  flex-shrink: 1;
  width: 100%;
  text-align: center;
  align-items: center;
  flex-direction: column;
  padding: 10px 20px;
  position: relative;
  justify-content: center;
  gap: 7px;

  &:hover {
    background-color: rgb(240, 246, 254, 1);
  }

  span {
    font-weight: bold;
    text-align: center;
    font-size: 12px;
    display: block;

    @media (max-width: 768px) {
      display: none;
    }
  }

  &.anonymization {
    padding: 10px 5px 5px;

    .badge {
      display: flex;
      background-color: #eee;
      border-radius: 5px;
      padding: 5px;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;

      @media (max-width: 768px) {
        background-color: #fff;
      }
    }
  }

  svg {
    display: flex;
  }

  @media (max-width: 768px) {
    &.anonymization {
      padding: 5px 5px 5px;
    }
  }
`

export default function Dock({ shadow, active }: { shadow?: boolean; active?: string }) {
  const isMobile = useMedia('(max-width: 768px)')

  return (
    <Wrapper $shadow={shadow}>
      <NavIconList>
        {/* HOME */}
        <Link
          href='/app'
          className='link link-welcome'
          style={
            isMobile ? { background: '#FFF' } : { background: active === 'home' ? '#F0F6FE' : '' }
          }
        >
          <BaSeIcon
            color={active === 'home' ? colors.oceanBlue : colors.darkGray}
            description='Home'
            name='buildings/home-2-line'
            size={36}
          />
          <span style={{ color: active === 'home' ? colors.oceanBlue : colors.darkGray }}>
            Home
          </span>
        </Link>

        {/* SENTINELA */}
        <Link
          href='/app/sentinel'
          className='link link-sentinel'
          style={
            isMobile
              ? { background: '#FFF' }
              : { background: active === 'sentinel' ? '#F0F6FE' : '' }
          }
        >
          <BaSeIcon
            color={active === 'sentinel' ? colors.oceanBlue : colors.darkGray}
            description='Sentinela'
            name='map-marker'
            size={36}
          />
          <span style={{ color: active === 'sentinel' ? colors.oceanBlue : colors.darkGray }}>
            Sentinela
          </span>
        </Link>

        {/* CHAT AGENT */}
        <Link
          href='/app/ai'
          className='link'
          style={
            isMobile ? { background: '#FFF' } : { background: active === 'ai' ? '#F0F6FE' : '' }
          }
        >
          <BaSeIcon
            color={active === 'ai' ? colors.oceanBlue : colors.darkGray}
            description='IA'
            name='robot'
            size={36}
          />
          <span style={{ color: active === 'ai' ? colors.oceanBlue : colors.darkGray }}>IA</span>
        </Link>

        {/* Insights */}
        <Link
          href='/app/insights'
          className='link link-insights'
          style={
            isMobile
              ? { background: '#FFF' }
              : { background: active === 'insights' ? '#F0F6FE' : '' }
          }
        >
          <BaSeIcon
            color={active === 'insights' ? colors.oceanBlue : colors.darkGray}
            description='Insights'
            name='list-ul'
            size={36}
          />
          <span style={{ color: active === 'insights' ? colors.oceanBlue : colors.darkGray }}>
            Insights
          </span>
        </Link>

        {/* BUSCAR EMPRESAS */}
        <Link
          href='/app/searchLegalEntity'
          className='link'
          style={
            isMobile
              ? { background: '#FFF' }
              : { background: active === 'searchLegalEntity' ? '#F0F6FE' : '' }
          }
        >
          <BaSeIcon
            color={active === 'searchLegalEntity' ? colors.oceanBlue : colors.darkGray}
            description='Buscar Empresas'
            name='search'
            size={36}
          />
          <span
            style={{ color: active === 'searchLegalEntity' ? colors.oceanBlue : colors.darkGray }}
          >
            Buscar <br /> Empresas
          </span>
        </Link>

        {/* RELATÓRIOS E ESTUDOS */}
        <Link
          href='/app/reports-and-studies'
          className='link link-reports-and-studies'
          style={
            isMobile
              ? {
                  background: '#FFF',
                  color: active === 'reports-and-studies' ? colors.oceanBlue : colors.darkGray,
                }
              : {
                  background: active === 'reports-and-studies' ? '#F0F6FE' : '',
                  color: active === 'reports-and-studies' ? colors.oceanBlue : colors.darkGray,
                }
          }
        >
          <BaSeIcon
            color={active === 'reports-and-studies' ? colors.oceanBlue : colors.darkGray}
            description='Relatórios e Estudos'
            name='books'
            size={36}
          />
          <span
            style={{ color: active === 'reports-and-studies' ? colors.oceanBlue : colors.darkGray }}
          >
            Relatórios e <br />
            Estudos
          </span>
        </Link>

        {/* OPÇÕES */}
        <Link
          href='/app/options'
          className='link'
          style={
            isMobile
              ? { background: '#FFF' }
              : { background: active === 'options' ? '#F0F6FE' : '' }
          }
        >
          <BaSeIcon
            color={active === 'options' ? colors.oceanBlue : colors.darkGray}
            description='Opções'
            name='system/settings-5-line'
            size={36}
          />
          <span style={{ color: active === 'options' ? colors.oceanBlue : colors.darkGray }}>
            Opções
          </span>
        </Link>
      </NavIconList>
    </Wrapper>
  )
}
